<template>
  <LegalPage page="contact">
    <h1>Contact Us</h1>

    <p class="intro">
      If you have any questions, bug reports, feature requests, or legal inquiries regarding
      InstaSave, please feel free to reach out to our team.
    </p>

    <div class="contact-card">
      <p>
        <strong>Email Support:</strong>
        <a href="mailto:support@instasaves.io">support@instasaves.io</a>
      </p>
      <p>
        <strong>Response Time:</strong> We aim to respond to all inquiries within
        24–48 business hours.
      </p>
    </div>
  </LegalPage>
</template>

<script>
import LegalPage from '@/components/LegalPage.vue';

export default {
  name: 'Contact',
  components: {
    LegalPage
  }
};
</script>
